import React from "react";
import SuccessToasterContainer from "../../assets/images/SuccessToasterContainer.svg";
import Button from "./Button.tsx";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  fieldTextStyle: React.CSSProperties;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onClose, fieldTextStyle }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 backdrop-blur-sm bg-black/40"
      tabIndex={-1}
      onKeyDown={(e) => { if (e.key === "Escape") onClose(); }}
    >
      <div
        className="relative max-w-[720px] w-full text-center drop-shadow-[0_0_30px_#2972D7]"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-success-title"
        aria-describedby="contact-success-desc"
      >
        <img
          src={SuccessToasterContainer}
          alt="Success"
          className="w-full h-auto"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center px-6">
          <h3
            id="contact-success-title"
            className="text-white text-[24px] font-gothicproMedium text-center"
            style={{
              lineHeight: "110%",
              letterSpacing: "0.01em",
              textShadow:
                "0px 0px 14.45px #2972D7, 0px 0px 28.9px #2972D7",
            }}
          >
            ¡Muchas gracias!
          </h3>
          <h4
            className="mt-1 text-white text-[24px] font-gothicproMedium text-center"
            style={{
              lineHeight: "110%",
              letterSpacing: "0.01em",
              textShadow:
                "0px 0px 14.45px #2972D7, 0px 0px 28.9px #2972D7",
            }}
          >
            Tu mensaje ha sido recibido
          </h4>
          <p
            id="contact-success-desc"
            className="mt-2"
            style={{ ...fieldTextStyle, color: "#C9C9C9" }}
          >
            Procederemos a procesar tu solicitud y nuestro equipo se <br></br>contactará contigo pronto.
          </p>
          <div className="mt-6">
            <Button
              type="button"
              varient="liquid"
              buttonClass="px-[20px] py-[6px]"
              autoFocus
              onClick={onClose}
            >
              <span className="text-[16px]">Cerrar</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
